import React, { useState } from 'react'
import { getLastPage } from '../../utils/getLastPage';
import { ApiHook } from '../../hooks/apiHook';
import TableMain from '../../components/Common/table/TableMain';

const AwardRewards = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortOptions, setSortOptions] = useState({
        sortBy: "",
        direction: ""
    })
    const report = ApiHook.CallAwardsRewards(currentPage, itemsPerPage, sortOptions.sortBy, sortOptions.direction)

    const headers = [
        '#',
        'Achieved Rank',
        'Award and Reward',
        'Award Achieved Date',
        'Rank Template'
    ];
    
    const lastPage = getLastPage(itemsPerPage, report?.data?.totalCount);
    return (
        <>
            <div className="table-responsive min-hieght-table">
                <TableMain
                    headers={headers}
                    data={report?.data?.data}
                    startPage={1}
                    currentPage={currentPage}
                    totalPages={lastPage}
                    type={"award-reward"}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    setCurrentPage={setCurrentPage}
                    setEpinSortOptions={setSortOptions}
                />
            </div>
        </>
    )
}

export default AwardRewards